import React, { useEffect } from 'react';
import { Accordion, Form } from 'react-bootstrap';
import { useGetActivesizeMutation } from '../../../Redux/SizeSlice';

const ProductSize = ({ selectedSizes, setSelectedSizes,limit,page,setPage,setlimit,search,setSearch }) => {

    const [productListFn, { data: productList, isSuccess, error, isLoading }] = useGetActivesizeMutation();

    useEffect(() => {
        productListFn()
    }, []);

    console.log('selectedSizes', selectedSizes)
    return (
        <React.Fragment>
            <Accordion defaultActiveKey='0'>
                <Accordion.Item eventKey='0'>
                    <Accordion.Header>
                        <span className="text-muted text-uppercase fs-13">Sizes</span>
                    </Accordion.Header>

                    <Accordion.Body className="text-body ">
                        <ul className="clothe-size list-unstyled hstack gap-3 mb-0 flex-wrap" id="size-filter">
                            {/* <li>
                                <Form.Check type="radio" name="sizes" value="xs" id="sizeXs" />
                                <Form.Label className="avatar-xs btn btn-soft-primary p-0 d-flex align-items-center justify-content-center rounded-circle" htmlFor="sizeXs">XS</Form.Label>
                            </li> */}

                            {
                                productList?.response?.map(size => {


                                    const isExit = selectedSizes?.includes(size?.id);




                                    return <li key={size?.id} >
                                        <Form.Check type="radio" name="sizes" value="s" id="sizeS" />
                                        <Form.Label checked={isExit} onClick={e => {
   
        setPage(1)
     
                                            setSelectedSizes(isExit ? selectedSizes?.filter(c => c !== size?.id) : [...selectedSizes, size?.id])

                                        }} style={{ backgroundColor: isExit ? "#4b93ff" : "", color: isExit ? "#fff" : "" }} className="avatar-xs btn btn-soft-primary p-0 d-flex align-items-center justify-content-center rounded-circle" htmlFor="sizeS">{size?.name}</Form.Label>
                                    </li>
                                })
                            }
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </React.Fragment>
    );
};

export default ProductSize
